export default "__VITE_ASSET__BDzk8ry8__"